import React from 'react';
import {Link} from "react-router-dom";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function ProspectClosedTasksTabActions() {
    const {t} = usePolTranslation();
    const { getRouteByNativeIdentifier, currentRoute } = useNavigation();
    const openTasksRoute = getRouteByNativeIdentifier('detail_open_tasks');

    return (
        <>
            <Link to={`/${resolveUrl(openTasksRoute?.url, { prospect: currentRoute.params.prospect })}/resume`} className="prospect-tab__action">
                <span>{t('tasks_summary')}</span>
            </Link>
        </>
    )
}
